/* sb-dc-ctatrim.js — one way forward, and no way to wipe the design by
   accident. 2026-09-05.

   Three edits to the editor's buttons:

     1. "Start over" is hidden. It clears the canvas, template and all, with no
        undo and no confirmation — and it sits directly beside the button that
        finishes the order. Nothing else on the screen is that destructive, and
        a customer who wants a clean canvas can pick a different template or
        reload.

     2. The "Continue" in the top bar is hidden. It does the same thing as
        "Review proof" at the bottom, so the screen offered two different words
        for one step and left the customer choosing between them.

     3. "Review proof" is relabelled "Add to Cart". It is the last thing the
        customer presses, and "review" made it sound like another inspection
        rather than the end of the job. NOTE: the button still opens the proof
        check first — only the wording changed. If the proof is ever moved or
        the flow gains another step, this label has to be looked at again.

   The "Continue" match is deliberately narrow: only a button in the bar that
   also shows the running total. The proof dialog has its own Continue, and
   hiding that one would strand the customer.

   Hidden, not removed — the app keeps its handlers, and deleting the CSS rule
   brings both buttons straight back.

   Diagnostics: window.__dcCtaTrim. */
(function () {
  'use strict';

  var OLD_CTA = /^review proof/i;
  var NEW_CTA = 'Add to Cart';
  var state = { startOver: 0, topContinue: 0, renamed: 0 };
  window.__dcCtaTrim = state;

  function css() {
    if (document.getElementById('sbdc-ctatrim-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-ctatrim-css';
    st.textContent = '[data-sbdc-cta="hide"]{display:none !important}';
    document.head.appendChild(st);
  }

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* The top bar is whatever box holds both the running total and the button. */
  function inTotalBar(el) {
    var n = el.parentElement;
    for (var i = 0; i < 4 && n; i++) {
      if (/total/i.test(n.textContent || '') && /\$\s?\d/.test(n.textContent || '')) return true;
      n = n.parentElement;
    }
    return false;
  }

  function sweep() {
    var bs = document.querySelectorAll('button, a');
    for (var i = 0; i < bs.length; i++) {
      var el = bs[i], t = text(el);
      if (!t) continue;

      if (!el.dataset.sbdcCta && /^start over/i.test(t)) {
        el.dataset.sbdcCta = 'hide'; state.startOver++;
        continue;
      }

      if (!el.dataset.sbdcCta && /^continue/i.test(t) && !el.closest('.sbdc-modal') && inTotalBar(el)) {
        el.dataset.sbdcCta = 'hide'; state.topContinue++;
        continue;
      }

      /* Relabel on every pass: the bar re-renders as the price changes and
         puts the old wording back. */
      if (OLD_CTA.test(t)) {
        var span = el.querySelector('span');
        var target = (span && OLD_CTA.test(text(span))) ? span : el;
        if (text(target) !== NEW_CTA) { target.textContent = NEW_CTA; state.renamed++; }
      }
    }
  }

  css();
  var t = setInterval(function () { try { sweep(); } catch (e) {} }, 350);
  window.addEventListener('pagehide', function () { clearInterval(t); });
})();
